module.exports = __webpack_public_path__ + "img/110.2.bf4fd9d3.png";